import type { DriverTermsAndConditionsType } from "@daytrip/legacy-enums";
import { useQuery } from "@tanstack/react-query";

import type { RpcClient } from "../../../../rpc-browser-sdk";

export function useDriverTermsAndConditions(type: DriverTermsAndConditionsType | null) {
    return useQuery({
        queryKey: ["driverTermsAndConditions.getLatestDriverTermsAndConditions", type],
        queryFn: () => {
            // Importing getRpcClient dynamically to avoid circular dependencies
            const getRpcClient = require("../../../../rpc-browser-sdk").getRpcClient as () => RpcClient;
            return getRpcClient().driverTermsAndConditions.getLatestDriverTermsAndConditions(type);
        },
        enabled: !!type,
        networkMode: "always",
    });
}
